/** @jsxImportSource @emotion/react */
import React from 'react'
import { css } from '@emotion/react'
import { Paper } from '@mui/material'

const styles = {
    paper: css`
        padding: 16px;
        height: 100%;
        display: flex;
        flex-direction: column;
    `,
    title: css`
        font-size: 14px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.4px;
        margin-bottom: 16px;
    `,
    body: css`
        flex: 1;
        min-height: 0;
    `,
    empty: css`
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        min-height: 240px;
        color: rgba(0, 0, 0, 0.5);
        font-size: 14px;
    `,
}

type Props = {
    title: string
    isEmpty?: boolean
    emptyText?: string
    children: React.ReactNode
}

export const DashboardChartCard: React.FC<Props> = ({ title, isEmpty, emptyText, children }) => (
    <Paper elevation={0} css={styles.paper}>
        <div css={styles.title}>{title}</div>
        <div css={styles.body}>{isEmpty ? <div css={styles.empty}>{emptyText}</div> : children}</div>
    </Paper>
)
